"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = exports.Reduction = exports.CarvanaPill = exports.KBBPill = exports.PillWrapper = exports.MiddleWrapper = exports.GreyBarSpace = exports.GreyBar = exports.GreyListSection = exports.LineItem = exports.DisclaimerText = exports.Price = exports.Title = exports.AuthTitleWrapper = exports.TitleWrapper = exports.Card = void 0;
var merch_components_1 = require("@carvana/merch-components");
exports.Card = (0, merch_components_1.createComponent)('div', {
    className: 'mx-auto flex w-full max-w-[424px] flex-col gap-16 rounded-md border border-grey-2 p-24'
});
exports.TitleWrapper = (0, merch_components_1.createComponent)('div', {
    className: 'flex flex-col gap-8 text-blue-6'
});
exports.AuthTitleWrapper = (0, merch_components_1.createComponent)('div', {
    className: 'flex flex-col gap-4 text-blue-6'
});
exports.Title = (0, merch_components_1.createComponent)('div', {
    className: 't-header-xs'
});
exports.Price = (0, merch_components_1.createComponent)('div', {
    className: 't-header-m'
});
exports.DisclaimerText = (0, merch_components_1.createComponent)('div', {
    className: 'text-grey-5 t-body-xs'
});
exports.LineItem = (0, merch_components_1.createComponent)('li', {
    className: 't-body-s flex justify-between text-blue-6'
});
exports.GreyListSection = (0, merch_components_1.createComponent)('ul', {
    className: 'm-0 flex flex-col gap-8 rounded-md bg-grey-1 p-16'
});
exports.GreyBar = (0, merch_components_1.createComponent)('div', {
    className: 'w-full" border-b border-grey-2'
});
exports.GreyBarSpace = (0, merch_components_1.createComponent)(exports.GreyBar, {
    className: 'my-4'
});
// GreatDealCard Styles
exports.MiddleWrapper = (0, merch_components_1.createComponent)('div', {
    className: 'flex flex-col gap-16'
});
exports.PillWrapper = (0, merch_components_1.createComponent)('div', {
    className: 'flex flex-col gap-8 border-grey-2 text-blue-6'
});
exports.KBBPill = (0, merch_components_1.createComponent)('div', {
    className: 't-body-s flex justify-between rounded-r-full bg-grey-1 px-16 py-12'
});
exports.CarvanaPill = (0, merch_components_1.createComponent)('div', {
    className: 't-header-xs flex w-3/4 items-center justify-between rounded-r-full bg-grey-2 px-16 py-12'
});
// PriceDropCard Styles
exports.Reduction = (0, merch_components_1.createComponent)('div', {
    className: 'py-2 t-body-s flex gap-4 rounded bg-grey-1 px-8 text-blue-7 m:py-[6px]'
});
exports.Text = (0, merch_components_1.createComponent)('div', {
    className: 'text-sm text-grey-5'
});
//# sourceMappingURL=Card.styles.js.map